import React from 'react';

import CookieBanner from 'components/complex/CookieBanner';
import { GetApp } from 'components/domains/promo/GetApp';

import styles from './PromoFooterContainer.module.scss';

type PromoFooterContainerProps = {
  availableCookie: boolean;
};

export const PromoFooterContainer: React.FC<PromoFooterContainerProps> = ({
    availableCookie
}) => {
  return (
    <div className={styles.container}>
      <GetApp />
      {availableCookie && 
        <CookieBanner />
      }
    </div>
  );
};
